import { Typography } from "antd";

const { Text } = Typography;

export const FullSubStatusName = ({ statusName, children, ...props }) => {
  return (
    <Text {...props}>
      <Text strong>{statusName}</Text> - {children}
    </Text>
  );
};
